import controller from './class-designer-link-common-editor.controller';
import template from './class-designer-link-common-editor.html';

export default {
	controller,
	template,
	bindings: {
		common: '<ngModel',
	},
	require: {
		linkEditor: '^^classDesignerLinkEditor',
	},
};
